/* unplugin-vue-components disabled */import { render } from "./userDetails.vue?vue&type=template&id=7a56f427&scoped=true"
import script from "./userDetails.vue?vue&type=script&lang=js"
export * from "./userDetails.vue?vue&type=script&lang=js"

import "./userDetails.vue?vue&type=style&index=0&id=7a56f427&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a56f427"]])

export default __exports__